import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Banner } from '../../../core/models/home.model';

@Component({
  selector: 'app-side-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="side-banner" *ngIf="banner">
      <a [href]="banner.link" [target]="banner.type === 'external' ? '_blank' : '_self'">
        <img [src]="banner.imageUrl" alt="Advertisement">
      </a>
    </div>
  `,
  styles: [`
    .side-banner {
      position: sticky;
      top: 100px;
      width: 160px;
      height: 600px;
      background: #f1f2f6;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 10px rgba(0,0,0,0.05);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    @media (max-width: 1200px) {
      .side-banner {
        display: none;
      }
    }
  `]
})
export class SideBannerComponent {
  @Input() banner?: Banner;
}
